import theme from "@/theme";
import { FC } from "react";

interface CashFastCircleProps {
  width?: number;
  height?: number;
  color?: string;
}

const CashFastCircle: FC<CashFastCircleProps> = ({
  width = 16,
  height = 16,
  color = theme.palette.custom.mainBlue,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00075 1.99926V3.21122"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5.63567C5.17529 4.14659 6.50778 3.07012 8.00043 3.21173"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00075 14.0013V12.7893"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0024 10.3652C10.8271 11.8543 9.49461 12.9308 8.00195 12.7892"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.926 5.10601C10.4746 3.89966 9.28748 3.13028 8.00195 3.21085"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.07617 10.8945C5.52761 12.1009 6.71468 12.8703 8.00021 12.7897"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 5.63574V5.63574C5.00001 6.66194 5.72435 7.54546 6.73061 7.74671L9.27026 8.25465C10.2765 8.45591 11.0009 9.33943 11.0009 10.3656V10.3656"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CashFastCircle;
